import React from 'react'
import './SliderWrapper.scss'

const SliderWrapper = ({ children }) => (
  <div className="slider-wrappernf">
    {children}
  </div>
);

export default SliderWrapper;
